import { META_HEADER_TITLE, META_LAYOUT } from "@core/constants";
import { ETAB_LAYOUTS, FUNNEL_SIGNUP_INFO, FUNNEL_SIGNUP_INFO_ALT, META_PROGRESS } from "@etab/config";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import { StorageManager } from "@core/managers/storage.manager";

import SeatsStep from "./Seats.step.vue";
import DescriptionStep from "./Description.step.vue";
import PhotoStep from "./Photo.step.vue";
import CropperStep from "./Cropper.step.vue";
// there are two paths for this funnel
// one path for the restaurants and coffee shops (full)
export const getInfoStepsFull = () => {
  return [
    {
      path: FUNNEL_SIGNUP_INFO.seats,
      name: FUNNEL_SIGNUP_INFO.seats,
      meta: {
        [META_PROGRESS]: 1,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.SEATS.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "8" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: SeatsStep,
    },
    {
      path: FUNNEL_SIGNUP_INFO.description,
      name: FUNNEL_SIGNUP_INFO.description,
      meta: {
        [META_PROGRESS]: 2,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.DESCRIPTION.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "9" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: DescriptionStep,
    },
    {
      path: FUNNEL_SIGNUP_INFO.photo,
      name: FUNNEL_SIGNUP_INFO.photo,
      meta: {
        [META_PROGRESS]: 3,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.PHOTO.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "10" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: PhotoStep,
    },
    {
      path: FUNNEL_SIGNUP_INFO.cropper,
      name: FUNNEL_SIGNUP_INFO.cropper,
      component: CropperStep,
      meta: {
        [META_LAYOUT]: ETAB_LAYOUTS.no,
      },
    },
  ];
};

// one path for the rest of the etabs (alt)
export const getInfoStepsAlt = () => {
  return [
    {
      path: FUNNEL_SIGNUP_INFO_ALT.description,
      name: FUNNEL_SIGNUP_INFO_ALT.description,
      meta: {
        [META_PROGRESS]: 1,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.DESCRIPTION.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "8" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: DescriptionStep,
    },
    {
      path: FUNNEL_SIGNUP_INFO_ALT.photo,
      name: FUNNEL_SIGNUP_INFO_ALT.photo,
      meta: {
        [META_PROGRESS]: 2,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.PHOTO.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "9" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: PhotoStep,
    },
    {
      path: FUNNEL_SIGNUP_INFO_ALT.cropper,
      name: FUNNEL_SIGNUP_INFO_ALT.cropper,
      component: CropperStep,
      meta: {
        [META_LAYOUT]: ETAB_LAYOUTS.no,
      },
    },
  ];
};
